module.exports = __webpack_public_path__ + "img/refund.02814429.svg";